import './ModuloCorsi.css'
import React, { useState, useEffect, useRef } from 'react';
import HTMLReactParser from 'html-react-parser';

const ajax_endpoint = "https://betterdays.it/school-server/ajax.php";

function set_stato_da_url() {
	if (document.location.toString().match(/\?paymentok$/)) {
		return "paymentok";
	}
	if (document.location.toString().match(/\?paymentok2$/)) {
		return "paymentok";
	}
	return '';
}

function getCorsoArId ( statoattuale ) {
	if("undefined" != typeof(statoattuale)) {
		for(let i=0;i<statoattuale.corsiDati.length;i++) {
			if (statoattuale.corsiDati[i].id== statoattuale.selezionato) return i;
		}
	}
}

function BadgeCorsoForm( { statoattuale } ) {
	let pos = getCorsoArId(statoattuale);
	if ("undefined"!=typeof(pos)) {
			const obj = statoattuale.corsiDati[pos];

			return (<div className={'pledge ' + obj.id}>
				<span className="label">{obj.name}</span>
				<h4>{HTMLReactParser(obj.titolo)}</h4>					
				<p>{HTMLReactParser(obj.descrizione)}</p>
				<p className="quando">{HTMLReactParser(obj.pledgetextshort)}</p>

				<span className="compra flex">
					<span className="prezzo">
						<b className="gradient">{obj.prezzo} €</b>
						<span className="small">{HTMLReactParser(obj.IVAlabel)}</span>
					</span>
				</span>

			</div> )

	} else {
		return (<div className="pledge">
				<span className="label">Not found</span>
			</div>)
	}

	
}

function ElencoCorsi( { statoattuale, onSelezionaCorso } ) {

	function handleClickSelectCorso(event,id) {
		event.preventDefault();
		let ba =  { ...statoattuale, selezionato :  id }
		onSelezionaCorso(ba); // funzione del parent!
	}



	if(!statoattuale)  {
		return ( <div>Niente </div> ) 
	} else


	return (
	  <section className="wrapper" id="corsi">
			<h2 className="gradient">corsi</h2>
		  {statoattuale.corsiDati.map((obj,index) => (
			<div key={obj.id} className={'flex bglogo ' + obj.id}>
				<div className={'infocorso ' + (index%2==1 ? 'invert' : '')}>
					<h3>{HTMLReactParser(obj.titolo)}</h3>
					<p>{HTMLReactParser(obj.descrizione)}</p>
					<div className="columns flex">
						<div className="col1">
							<div>{HTMLReactParser(obj.docenti)}</div>
							<div>{HTMLReactParser(obj.ospiti)}</div>
						</div>
						<div className="col2">
							<span className="small">PROGRAMMA:</span><br />
							{HTMLReactParser(obj.programma)}
						</div>
					</div>
				</div>
				<div className={'pledge ' + (index%2==1 ? 'invert' : '')}>
					<span className="label">{HTMLReactParser(obj.name)}</span>
					<p>{HTMLReactParser(obj.pledgetext)}</p>
					<span className="compra flex">
						<span className="prezzo">
							<b className="gradient">{HTMLReactParser(obj.prezzo)} €</b>
							<span className="small">{HTMLReactParser(obj.IVAlabel)}</span>
						</span>
						<a href="#" className="btn" data-rel={obj.name} data-azione={obj.azione} 
							onClick={(event) => { handleClickSelectCorso(event,obj.id) }}>{HTMLReactParser(obj.azioneLabel)}</a>
					</span>
				</div>
			</div>
		  ))}
		</section>
	)

}


function FormCorso ( { statoattuale, onSelezionaCorso }) {

	const formRef = useRef(null);
	const formContainerRef = useRef(null);

	let pos = getCorsoArId(statoattuale);

	// let apri = true;

	let corso_azioneLabelEstesa = "non disponibile"
	let corso_name = "corso 0"
	let corso_azione = "nulla"
	let corso_opzioni = ""
	let corso_modalita = "";

	if ("undefined" == typeof(pos)) {
		// apri = false;
		pos = 0;
	} else {
		corso_azioneLabelEstesa = statoattuale.corsiDati[pos].azioneLabelEstesa
		corso_name = statoattuale.corsiDati[pos].name
		corso_azione = statoattuale.corsiDati[pos].azione
		corso_opzioni = statoattuale.corsiDati[pos].opzioni ?? ""
		corso_modalita = statoattuale.corsiDati[pos].modalita ?? ""

	}

	function  handleClickChiudi() {
		let ba = {...statoattuale, selezionato:'', showRitorno : '', iscritto:'', prezzo:'' }
		onSelezionaCorso(ba);
	}

	function handleSendForm (e) {
		e.preventDefault();

		// clear err bordi rossi
		if (formRef.current) {
			const elems = formRef.current.querySelectorAll("input, select, span.err");
			Array.from(elems).forEach( (el) => { el.classList.remove("err");});
		}

		const f = formRef.current;
		if (!f) return;

		const data = new URLSearchParams();
		for (const pair of new FormData(f)) {
			data.append(pair[0], pair[1]);
		}
		

		//
		// invio dati in POST
		fetch( ajax_endpoint , {
			method: 'POST',
			headers: { "Content-type": "application/x-www-form-urlencoded; charset=UTF-8" },
			body: data
		})
		  .then((response) => response.json())
		  .then((data) => {
				var err = "";
				if (typeof(data.id) != "undefined") {

					if(typeof(data.url) != "undefined") {
						// go to stripe | coinbase | bonifico

						let n = document.getElementById("nome").value + " " + document.getElementById("cognome").value;
						let p = statoattuale.corsiDati[pos].prezzo;
	
						if(data.url=='?waitbonifico') {
							
							let ba = {  ...statoattuale, 
									showRitorno:'waitbonifico',
									iscritto: n,
									prezzo: p,
								}

							onSelezionaCorso(ba);

						} else if( data.url=='?lista') {
							//alert(data.url);
							let ba = { ...statoattuale, showRitorno:'lista',iscritto: n, prezzo:p }
							onSelezionaCorso(ba);

						} else {
	
							document.location = data.url;
							
						}


					} else {
						alert("manca url")
					}

				} else if (typeof(data.err) != "undefined") {
					// show error
					alert(data.err);
				} else {
					// errori validazione form
					let firstErr = "";
					data.forEach(e => {
						let label = e[0];
						firstErr = firstErr==""? label : firstErr;
							if (f.elements[label]) {
								f.elements[label].classList.add("err");
								if(f.elements[label].getAttribute("type") == "radio" || f.elements[label].getAttribute("type") == "checkbox") {
									f.elements[label].parentElement.classList.add("err");
								}
							}
							if(err=="") err = label;
						});
						if(err!="" && formContainerRef.current && f.elements[firstErr]) {
							// scroll to first err
							formContainerRef.current.scrollTo(
							{   top: f.elements[firstErr].offsetTop - f.elements[firstErr].offsetHeight ,
								behavior:'smooth'})
					}
				}
			});




	}


	if(!statoattuale) {

		return ( <div>no form</div> )
	} else {
		


	return (
		<>

		<div id="hiddenform" ref={formContainerRef} className={'hiddenform wrapper flex ' + (statoattuale.selezionato!='' ? 'open' : '') } >
			<div id="top3" className="top">
				<span id="logo3" className="flex logo"><img src='img/Vector.svg' alt="logo better days school" /> <span><b>BETTER DAYS SCHOOL</b><i>Learn&Connect</i></span></span>
			</div>
			<div id="nav3" className="nav">
				<nav className="flex"></nav>
			</div>

			<span className="chiudi icon-cancel" onClick={() => { handleClickChiudi() }}></span>
		
			<div className="iscriz">

				<h2>Iscriviti al corso</h2>

				<div className="pledges"><BadgeCorsoForm statoattuale={statoattuale}/></div>


				<form className="form" id="form" ref={formRef}>

					<input type="hidden" name="corso" id="corso" value={ corso_name  } />
					<input type="hidden" name="listadattesa" id="listadattesa" value={ corso_azione } />

					<div>
						<label>Nome*</label>
						<input type="text" name="nome" id="nome" />
					</div>


					<div>
						<label>Cognome*</label>
						<input type="text" name="cognome" id="cognome" />
					</div>


					<div>
						<label>Email*</label>
						<input type="text" name="email" id="email" />
					</div>


					<div>
						<label>Conferma email*</label>
						<input type="text" name="email2" id="email2" />
					</div>


					<div>
						<label>Indirizzo</label>
						<input type="text" name="indirizzo" id="indirizzo" />
					</div>


					<div>
						<label>Città</label>
						<input type="text" name="citta" id="citta" />
					</div>


					<div>
						<label>CAP</label>
						<input type="text" name="cap" id="cap" />
					</div>


					<div>
						<label>Provincia*</label>
						<input type="text" name="provincia" id="provincia" />
					</div>


					<div>
						<label>Numero di telefono*</label>
						<input type="text" name="tel" id="tel" />
					</div>


					{corso_modalita && (
						<div>
							<label>Modalità di partecipazione*</label>
							<select name="modalita" id="modalita">
							{corso_modalita.split(";").map((modalita, index) => (
								<option key={index}>{modalita.trim()}</option>
							))}
							</select>
						</div>
					)}
					<div>
						<label>Metodo di pagamento*</label>
						<span><input type="radio" name="metodo" value="carta" defaultChecked id="metodo" /> Carta di credito</span>
						<span><input type="radio" name="metodo" value="bonifico" /> Bonifico bancario</span>
						{/* <span><input type="radio" name="metodo" value="crypto" /> Cryptovalute</span> */}
					</div>

					{corso_opzioni && (
						<div>
							<label>Scegli l'opzione*</label>
							{corso_opzioni.split(";").map((opzione, index) => (
								<span key={index}>
									<input
										type="radio"
										name="opzione"
										value={opzione.trim()}
										defaultChecked={index === 0} // Predefinisci la prima opzione come selezionata
									/>{" "}
									{opzione.trim()}
								</span>
							))}
						</div>
					)}


					{corso_opzioni && (
						<div></div>
					)}

					<div>
						<label>Privacy*</label>
						<span><input type="checkbox" name="privacy" value="1" id="privacy" 
							defaultChecked = {false}
						/> Accetto l'<a href="https://betterdays.it/privacy-policy/" target="_blank" rel="noreferrer">informativa sulla privacy</a></span>
					</div>


					<div id="procedi">
						<a href="#none" className="btn" id="gotopayment" onClick={(event) => { handleSendForm(event) }}>{corso_azioneLabelEstesa}</a>
					</div>

					<div id="asterisco">
						* Campi obbligatori
					</div>

				</form>

			</div>

		</div>


		<div id="hiddenresultsbonifico" className= {'hiddenform wrapper flex ' + (statoattuale.showRitorno==='waitbonifico' ? 'open' : '') }>
			<div id="top3" className="top">
				<span id="logo3" className="flex logo"><img src='img/Vector.svg' alt="logo better days school" /> <span><b>BETTER DAYS SCHOOL</b><i>Learn&Connect</i></span></span>
			</div>
			<div id="nav3" className="nav">
				<nav className="flex"></nav>
			</div>

			<span className="chiudi icon-cancel" onClick={() => { handleClickChiudi() }}></span>
		
			<div>

				<h2>Grazie.</h2>
				<p>
				Ti abbiamo inviato una email con le informazioni per completare l'iscrizione.<br />
				Puoi effettuare il bonifico utilizzando questi dati:
				</p>
				<p>		<span>IBAN: <b>IT81F0503401688000000020457</b></span>
						<span>Banca: <b>Banco BPM</b></span>
						<span>Intestato a: <b>BETTER DAYS SRL</b></span>
						<span>Causale: <b>Iscrizione { statoattuale.selezionato }</b></span>
						<span>Per <b>{statoattuale.iscritto }</b></span>
						<span>Importo: <b>{ statoattuale.prezzo  }€</b></span>
				</p>
			</div>
		</div>



		<div id="hiddenresultslista" className= {'hiddenform wrapper flex ' + (statoattuale.showRitorno==='lista' ? 'open' : '') }>
			<div id="top3" className="top">
				<span id="logo3" className="flex logo"><img src='img/Vector.svg' alt="logo better days school" /> <span><b>BETTER DAYS SCHOOL</b><i>Learn&Connect</i></span></span>
			</div>
			<div id="nav3" className="nav">
				<nav className="flex"></nav>
			</div>

			<span className="chiudi icon-cancel" onClick={() => { handleClickChiudi() }}></span>
		
			<div>

				<h2>Grazie!</h2>
				<p>Verrai ricontattato appena dei posti saranno disponibili.</p>

			</div>
		</div>


		<div id="hiddenresultspayment" className= {'hiddenform wrapper flex ' + ( (statoattuale.showRitorno==='paymentok' || statoattuale.showRitorno==='paymentok2') ? 'open' : '') }>
			<div id="top3" className="top">
				<span id="logo3" className="flex logo"><img src='img/Vector.svg' alt="logo better days school" /> <span><b>BETTER DAYS SCHOOL</b><i>Learn&Connect</i></span></span>
			</div>
			<div id="nav3" className="nav">
				<nav className="flex"></nav>
			</div>

			<span className="chiudi icon-cancel" onClick={() => { document.location = "./" }}></span>
		
			<div>

				<h2>Grazie!</h2>
				<p>Ci vediamo al corso.</p>

			</div>
		</div>


		</>
	)


	}

}

function ModuloCorsi() {

	const [stato, setCorsoState] = useState({selezionato:'', corsiDati:[], loaded:false, showRitorno: set_stato_da_url()});
	
	// Gestisce lo scroll lock del body quando il form è aperto
	useEffect(() => {
		if (stato.selezionato !== '' || stato.showRitorno !== '') {
			document.body.classList.add('scrollo');
		} else {
			document.body.classList.remove('scrollo');
		}
		// Cleanup quando il componente viene smontato
		return () => {
			document.body.classList.remove('scrollo');
		};
	}, [stato.selezionato, stato.showRitorno]);
	
	const getData=()=>{

			let ba = { selezionato :  '',  corsiDati : [], loaded : true, showRitorno: set_stato_da_url(), prezzo:'',iscritto:'' }
			selectCorso( ba );

			fetch( ajax_endpoint + "?op=getcorsi",{
			  headers : { 
				'Content-Type': 'application/json',
				'Accept': 'application/json'
			   }
			})
			  .then((response) => response.json())
			  .then((data) => {
				console.log("ok " + data.length);
				//corsiDati = data;
				let ba = { selezionato :  '',  corsiDati : data, loaded : true, showRitorno:set_stato_da_url(), prezzo:'',iscritto:'' }
				selectCorso( ba )
				console.log(data[0].id);
			  });
		 
	}

	
	useEffect(() => {
		if(!stato.loaded) getData();
	});
	

	
	

	function  selectCorso( a ) {
		setCorsoState(a);
		
	}

	return (
		<>

				<ElencoCorsi statoattuale={stato}  onSelezionaCorso={(a) => { selectCorso(a) } }/>

				<FormCorso statoattuale={stato}  onSelezionaCorso={(a) => { selectCorso(a) } }/>

		</>


	)

}


export default ModuloCorsi;